import {CommentDialog, ConfirmationDialog, SaveTemplateDialog} from '@dv5/components'
import {Comment, DocumentPart, DvDocument, PartType, TemplateType} from '@dv5/domain'
import React, {FC} from "react"
import {ChangePartDocumentDialog} from "./ChangePartDocumentDialog"
import {ChangePartTypeDialog} from './ChangePartTypeDialog'

interface Props {
    part: DocumentPart
    showChangeTypeDialog: boolean
    onChangeType: (type: PartType) => void
    onCancelChangeType: () => void
    showDeleteConfirmation: boolean
    onConfirmDelete: () => void
    onCancelDelete: () => void
    showSaveTemplateDialog: boolean
    onSaveTemplate: (title: string) => void
    onCancelSaveTemplate: () => void
    showChangeDocumentDialog: boolean
    currentDocumentId: string
    documents: Array<DvDocument>
    onChangeDocument: (newDocumentId: string) => void
    onCancelChangeDocument: () => void
    showAddCommentDialog: boolean
    comments: Comment[]
    onEditComment: (commentId: string, content: string) => void
    onGetComment: (sourceItemId: string) => void
    onSendComment: (content: string) => void
    onDeleteComment: (commentId: string) => void
    onCloseComment: () => void
}

const getRemovePartQuestions = (part: DocumentPart): string => {
    if (part.partHeader && part.partHeader.length > 0) {
        return `Are you sure you want to remove the part "${part.partHeader}"?`
    }
    return `Are you sure you want to remove the part without header?`
}

export const DocumentPartDialogs: FC<Props> = ({
                                                    part,
                                                    showChangeTypeDialog,
                                                    onChangeType,
                                                    onCancelChangeType,
                                                    showDeleteConfirmation,
                                                    onConfirmDelete,
                                                    onCancelDelete,
                                                    showSaveTemplateDialog,
                                                    onSaveTemplate,
                                                    onCancelSaveTemplate,
                                                    showChangeDocumentDialog,
                                                    currentDocumentId,
                                                    documents,
                                                    onChangeDocument,
                                                    onCancelChangeDocument,
                                                    showAddCommentDialog,
                                                    comments,
                                                    onEditComment,
                                                    onGetComment,
                                                    onSendComment,
                                                    onDeleteComment,
                                                    onCloseComment,
                                                }) => {
    return (
        <>
            {showChangeTypeDialog && (
                <ChangePartTypeDialog
                    currentType={part.partType}
                    onConfirm={onChangeType}
                    onCancel={onCancelChangeType}
                />
            )}
            {showDeleteConfirmation && (
                <ConfirmationDialog
                    message={getRemovePartQuestions(part)}
                    onConfirm={onConfirmDelete}
                    onCancel={onCancelDelete}
                />
            )}
            {showSaveTemplateDialog && (
                <SaveTemplateDialog
                    title="Save as Template"
                    templateType={TemplateType.DOCUMENT_PART}
                    onSave={onSaveTemplate}
                    onCancel={onCancelSaveTemplate}
                />
            )}
            {showChangeDocumentDialog && (
                <ChangePartDocumentDialog
                    currentDocumentId={currentDocumentId}
                    documents={documents}
                    onConfirm={onChangeDocument}
                    onCancel={onCancelChangeDocument}
                />
            )}
            {showAddCommentDialog && (
                <CommentDialog
                    isOpen={showAddCommentDialog}
                    sourceItemId={part.id}
                    comments={comments}
                    onEdit={onEditComment}
                    onGetComment={onGetComment}
                    onSend={onSendComment}
                    onDelete={onDeleteComment}
                    onClose={onCloseComment}
                />
            )}
        </>
    )
}
